var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 88C31.8694 88 22 78.1306 22 66C22 53.8694 31.8694 44 44 44C56.1306 44 66 53.8694 66 66C66 78.1306 56.1306 88 44 88ZM44 55C37.9347 55 33 59.9347 33 66C33 72.0653 37.9347 77 44 77C50.0653 77 55 72.0653 55 66C55 59.9347 50.0653 55 44 55ZM44 154C31.8694 154 22 144.131 22 132C22 119.869 31.8694 110 44 110C56.1306 110 66 119.869 66 132C66 144.131 56.1306 154 44 154ZM44 121C37.9347 121 33 125.935 33 132C33 138.065 37.9347 143 44 143C50.0653 143 55 138.065 55 132C55 125.935 50.0653 121 44 121ZM44 220C31.8694 220 22 210.131 22 198C22 185.869 31.8694 176 44 176C56.1306 176 66 185.869 66 198C66 210.131 56.1306 220 44 220ZM44 187C37.9347 187 33 191.935 33 198C33 204.065 37.9347 209 44 209C50.0653 209 55 204.065 55 198C55 191.935 50.0653 187 44 187ZM242 60.5H77V71.5H242V60.5ZM242 126.5H77V137.5H242V126.5ZM242 192.5H77V203.5H242V192.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.72da4042496337bffd31a032bf31e74b.svg";
export { ForwardRef as ReactComponent };